var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"blockchain-address"}},[_vm._v("0x1234567..789102adfa")])
}
var staticRenderFns = []

export { render, staticRenderFns }